<template>
    <section class="singpause-schulen-ogs">
        <div class="ogs">
            <h4>OGS</h4>
            <Table
                bordered
                striped
                small
                showFilter
                :responsive="true"
                :fields="fields"
                :items="items"
                :isBusy="busy"
                :size="size"
                sortBy="from_date"
                emptyText="Es wurden bisher keine Zuweisungen von Klassen für diese Schule vorgenommen"
            >
                <template v-slot:thead-top="{ data }">
                    <b-tr>
                        <b-td :colspan="data.columns - 1"></b-td>
                        <b-td class="text-center">
                            <b-button
                                v-if="checkRight('write')"
                                :size="size"
                                @click="extendAll"
                                variant="link"
                                :disabled="busy || extending.busy"
                                class="mv-table-action-btn"
                                >Alle Übertragen</b-button
                            >
                        </b-td>
                    </b-tr>
                </template>
                <template v-slot:additiv="{ row: row }">
                    <b-input
                        v-model="row.item.additiv"
                        :size="size"
                        :disabled="!checkRight('write')"
                    />
                    <template v-if="validation">
                        <template v-if="validation[row.item.id]">
                            <p
                                class="small text-danger m-0 p-0"
                                v-for="error in validation[row.item.id].additiv"
                                :key="error"
                            >
                                {{ error }}
                            </p>
                        </template>
                    </template>
                </template>

                <template v-slot:gtk="{ row: row }">
                    <b-input
                        v-model="row.item.gtk"
                        :size="size"
                        :disabled="!checkRight('write')"
                    />
                </template>

                <template v-slot:total="{ row: row }">
                    {{ calculateTotal(row.item.additiv, row.item.gtk) }}
                </template>

                <template v-slot:anteil="{ row: row }">
                    <b-input
                        v-model="row.item.anteil"
                        :size="size"
                        :disabled="!checkRight('write')"
                    />
                </template>

                <template v-slot:fv="{ row: row }">
                    <b-input
                        v-model="row.item.fv"
                        :size="size"
                        :disabled="!checkRight('write')"
                    />
                </template>

                <template v-slot:sp_kl="{ row: row }">
                    {{ row.value }}
                </template>

                <template v-slot:pauschal="{ row: row }">
                    <b-input
                        v-model="row.item.pauschal"
                        :size="size"
                        :disabled="!checkRight('write')"
                    />
                </template>

                <template v-slot:schueler="{ row: row }">
                    <b-input
                        v-model="row.item.schueler"
                        :size="size"
                        :disabled="!checkRight('write')"
                    />
                </template>

                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        @click="extendItem(row.id)"
                        variant="link"
                        :disabled="busy || extending.busy"
                        class="mv-table-action-btn"
                        >Übertragen</b-button
                    >
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="removeItem(row.id)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>

                <template v-slot:custom-foot>
                    <b-tr>
                        <b-td>Neuen Datensatz anlegen:</b-td>
                        <b-td>
                            <b-input
                                v-model="newItem.current.additiv"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                            />
                            <template v-if="newItemValidation.errors.additiv">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors
                                        .additiv"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input
                                v-model="newItem.current.gtk"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                            />
                            <template v-if="newItemValidation.errors.gtk">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors
                                        .gtk"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            {{
                                calculateTotal(
                                    newItem.current.additiv,
                                    newItem.current.gtk
                                )
                            }}
                        </b-td>
                        <b-td>
                            <b-input
                                v-model="newItem.current.anteil"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                            />
                            <template v-if="newItemValidation.errors.anteil">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors
                                        .anteil"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input
                                v-model="newItem.current.fv"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                            />
                            <template v-if="newItemValidation.errors.fv">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors.fv"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input
                                v-model="newItem.current.sp_kl"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                            />
                            <template v-if="newItemValidation.errors.sp_kl">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors
                                        .sp_kl"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input
                                v-model="newItem.current.pauschal"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                            />
                            <template v-if="newItemValidation.errors.pauschal">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors
                                        .pauschal"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input
                                v-model="newItem.current.schueler"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                            />
                            <template v-if="newItemValidation.errors.schueler">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in newItemValidation.errors
                                        .schueler"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td
                            ><b-button
                                variant="link"
                                :size="size"
                                :disabled="busy || newItemValidation.busy"
                                @click="addItem"
                                >Anlegen</b-button
                            ></b-td
                        >
                    </b-tr>
                </template>
            </Table>
        </div>
        <hr />
        <div class="sp-school-additional-info">
            <h4>Zusatzinformationen für Schule</h4>
            <b-form-group
                :label-cols-sm="3"
                :label-cols-lg="4"
                label="SingPause seit"
                label-for="sp_since"
                description="Hier nur Jahreszahlen hinterlegen, z.B. 2009"
                :label-size="size"
                :disabled="meta.busy"
            >
                <b-input
                    id="sp_since"
                    placeholder="z.B. 2009"
                    :size="size"
                    :disabled="meta.busy"
                    v-model="meta.sp_since"
                />
            </b-form-group>
        </div>
    </section>
</template>

<script>
import shortid from "shortid";
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import SingPause from "@/mixins/SingPause/SingPause";
import SingPauseOGS from "@/mixins/SingPause/SingPauseOGS";
import { ApiFactory } from "@/api/ApiFactory.js";
import Table from "@/components/Table/Table";
import SchoolYearDateInput from "@/components/SchoolYearDateInput/SchoolYearDateInput";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    name: "SingPauseSchulenOGS",
    mixins: [CommonView, Size, Currency, SingPause, SingPauseOGS],
    props: ["id", "refresh", "validation"],
    components: {
        Table
        // SchoolYearDateInput
    },
    data() {
        return {
            api: SingPauseApi,
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "additiv",
                    label: "OGS additiv",
                    sortable: true
                },
                {
                    key: "gtk",
                    label: "OGS GTK",
                    sortable: true
                },
                {
                    key: "total",
                    label: "OGS gesamt",
                    sortable: true
                },
                {
                    key: "anteil",
                    label: "Anteil",
                    sortable: true
                },
                {
                    key: "fv",
                    label: "Förderverein",
                    sortable: true
                },
                {
                    key: "sp_kl",
                    label: "SP-Klassen",
                    sortable: true
                },
                {
                    key: "pauschal",
                    label: "Pauschalkosten",
                    sortable: true
                },
                {
                    key: "schueler",
                    label: "Anzahl Schüler",
                    sortable: true
                },
                {
                    key: "actions",
                    label: "Aktionen",
                    class: "text-center"
                }
            ],
            newItem: {
                default: {
                    id: null,
                    schule_id: null,
                    additiv: null,
                    gtk: null,
                    anteil: null,
                    fv: null,
                    sp_kl: null,
                    pauschal: null,
                    schueler: null
                },
                current: {
                    id: null,
                    schule_id: null,
                    additiv: null,
                    gtk: null,
                    anteil: null,
                    fv: null,
                    sp_kl: null,
                    pauschal: null,
                    schueler: null
                }
            },
            newItemValidation: {
                busy: false,
                errors: {}
            },
            meta: {
                busy: false,
                sp_since: null
            }
        };
    },
    created() {
        this.fetchMeta();
    },
    watch: {
        selectedSchoolYear: {
            handler() {
                this.fetch();
            }
        },
        refresh: {
            handler() {
                this.fetch();
            }
        },
        items: {
            handler(val) {
                this.$emit("update", val);
            },
            deep: true,
            immediate: true
        },
        "meta.sp_since": {
            handler(val) {
                this.$emit("updateMeta", { sp_since: val });
            },
            immediate: true
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getOGSForSchule(
                this.id,
                this.selectedSchoolYear
            );
            if (response.ok && response.json.collection) {
                var items = response.json.collection;
                items = items.map(item => this.process(item));
                this.items = items;
                this.registerRights(response);
            } else {
                this.items = [];
                this.registerRights(response);
            }
            this.busy = false;
        },
        async fetchMeta() {
            this.meta.busy = true;
            const response = await this.api.getMeta(this.id, "sp_since");
            if (response.ok) {
                this.meta.sp_since = response.json.value;
            }
            this.meta.busy = false;
        },
        calculateTotal(additiv, gtk) {
            if (additiv && gtk) {
                return parseFloat(additiv) + parseFloat(gtk)
            } else {
                return "-";
            }
        },
        async addItem() {
            this.newItem.current["id"] = "new_" + shortid.generate();
            this.newItemValidation.busy = true;
            const validate = await SingPauseApi.validateOGS(
                this.id,
                this.newItem.current
            );
            if (validate.ok) {
                this.items.push(this.newItem.current);
                this.newItem.current = { ...this.newItem.default };
            } else {
                console.error("Validaton error:", validate);
                this.newItemValidation.errors = validate.json.validation;
            }
            this.newItemValidation.busy = false;
        },
        removeItem(id) {
            this.items = this.items.filter(item => item.id !== id);
        },
        async extendAll() {
            this.extending.busy = true;
            const response = await SingPauseApi.extendMultipleOGSEntriesForSingleiter(
                this.id,
                this.selectedSchoolYear
            );
            if (response.ok) {
                this.makeToast(
                    "Übertragung erfolgreich",
                    `Der ausgewählten Datensätze wurden korrekt in das nächste Schuljahr übertragen`
                );
            } else {
                this.makeToast(
                    "Übertragung fehlerhaft",
                    `Der ausgewählten Datensätze wurde nicht übertragen!`,
                    "danger"
                );
            }
            this.extending.busy = false;
        }
    }
};
</script>
